import { consoleApi } from '../api/client';
import { withConsoleBase } from '../config';

export async function finishGoogleMailConnection(root: HTMLElement) {
  const params = new URLSearchParams(window.location.search);
  // Remove Google's callback parameters before session requests or application rendering.
  window.history.replaceState(null, '', window.location.pathname);
  root.className = 'boot-screen';
  root.textContent = 'Completing Google mailbox connection…';
  let result = 'connected';
  try {
    if (params.has('error')) throw new Error('Google access was not approved. Start again from Support inbox.');
    const code = params.get('code') || '';
    const state = params.get('state') || '';
    if (!code || code.length > 2048 || !/^[A-Za-z0-9_-]{40,128}$/.test(state)) throw new Error('This connection link is incomplete. Start again from Support inbox.');
    const session = await consoleApi.session();
    if (!session.authenticated || !session.csrfToken) throw new Error('Your GTM login expired. Sign in and start the Google connection again.');
    await consoleApi.mailGoogleComplete(state, code, session.csrfToken);
  } catch (error) {
    result = 'failed';
    root.textContent = error instanceof Error ? error.message : 'Google connection failed. Start again from Support inbox.';
    const link = document.createElement('a');
    link.href = withConsoleBase('/emails');
    link.textContent = 'Return to Support inbox';
    root.appendChild(link);
  }
  if (result === 'connected') window.location.replace(withConsoleBase('/emails?google=connected'));
}
